import {
    ExpertCertificate,
    ApplicantQualification,
    ExpertEcs,
    ApplicantQualificationDetails,
    ISetApplicantTempPassword,
    SetApplicantTempPassword,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import moment from 'moment';
import apiConnector from '../../api/ApiConnector';

const initialState: IState = {
    certificateList: null,
    qualificationsList: null,
    qecsList: null,
    applicantQualificationDetails: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setCertificateList(state, certificateList: ExpertCertificate | null) {
            return { ...state, certificateList };
        },
        setApplicantQualificationDetails(state, applicantQualificationDetails: ApplicantQualificationDetails | null) {
            return { ...state, applicantQualificationDetails };
        },
        setQualificationsList(state, qualificationsList: ApplicantQualification[] | null) {
            return { ...state, qualificationsList };
        },
        setQecsList(state, qecsList: ExpertEcs | null) {
            return { ...state, qecsList };
        },
        clearState() {
            return {
                ...initialState,
            };
        },
    },
    effects: (dispatch: any) => ({
        /* Certificate */
        async getCertificateListAsync() {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertCertificates());

            this.setCertificateList(certificateList);
        },
        async addCertificateAsync({ certificateData }: IAddCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.addExpertCertificateFix(
                certificateData.regNumber,
                certificateData.issueDate,
                certificateData.expireDate,
                certificateData.file || new File([], ''),
            ));

            if (certificateList) {
                this.setCertificateList(certificateList);
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно добавлен!', level: 'success' }]);
            }

            return certificateList;
        },
        async deleteCertificateAsync({ certificateId }: IDeleteCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient.removeExpertCertificate(certificateId));

            this.setCertificateList(certificateList);
            if (certificateList) {
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно удален!', level: 'success' }]);
            }
        },
        async updateCertificateAsync({ certificateId, certificateData }: IUpdateCertificateProps) {
            const certificateList = await apiConnector.execApi(dispatch, apiClient => apiClient
                .updateExpertCertificateFix(certificateId, certificateData.regNumber, certificateData.issueDate, certificateData.expireDate, certificateData.file));

            if (certificateList) {
                this.setCertificateList(certificateList);
                dispatch.notifications.addNotification([{ message: 'Сертификат успешно обновлен!', level: 'success' }]);
            }

            return certificateList;
        },
        /* Qualifications */
        async getQualificationsListAsync() {
            const qualificationsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getExpertQualifications());

            this.setQualificationsList(qualificationsList);
        },
        async getQecsAsync({
            searchField, searchTerm, page, pageSize, sortOrder, sortField,
        }: IGetQecsListProps) {
            const qecsList = await apiConnector.execApi(dispatch, apiClient => apiClient.getQecs(searchField, searchTerm, page, pageSize, sortOrder, sortField));

            this.setQecsList(qecsList);
        },
        /* Clear state */
        clearExpertState() {
            this.clearState();
        },
        /* Other */
        async getQualificationDetailsAsync(examApplicationId: string) {
            const applicantQualificationDetails = await apiConnector.execApi(dispatch, apiClient => apiClient.getQualificationDetails(examApplicationId));

            this.setApplicantQualificationDetails(applicantQualificationDetails);
        },
        async setApplicantTempPasswordAsync({ applicantId, body }: ISetApplicantTempPass) {
            const res = await apiConnector.execApi(dispatch, apiClient => apiClient.setApplicantTempPassword(applicantId, new SetApplicantTempPassword(body)));

            if (res) {
                dispatch.notifications.addNotification([{ message: 'Временный пароль успешно добавлен', level: 'success' }]);
            }

            return res;
        },
    }),
});

export interface IUpdateCertificateProps {
    certificateId: string;
    certificateData: ICertificate;
}

export interface IAddCertificateProps {
    certificateData: ICertificate;
}

interface IGetQecsListProps {
    expertId?: string;
    searchField?: string;
    searchTerm?: string;
    page?: number;
    pageSize?: number;
    sortOrder?: boolean;
    sortField?: string;
}

interface ISetApplicantTempPass {
    applicantId: string;
    body: ISetApplicantTempPassword;
}

interface ICertificate {
    regNumber: string;
    issueDate: moment.Moment;
    expireDate: moment.Moment;
    file?: File;
}

interface IDeleteCertificateProps {
    certificateId: string;
}

interface IState {
    certificateList: ExpertCertificate[] | null;
    qualificationsList: ApplicantQualification[] | null;
    qecsList: ExpertEcs | null;
    applicantQualificationDetails: ApplicantQualificationDetails | null;
}
